var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463 392.668H49.0012C30.2194 392.668 14.9943 377.442 14.9943 358.661V49.589C14.9943 30.8072 30.2194 15.582 49.0012 15.582H463C481.782 15.582 497.007 30.8072 497.007 49.589V358.661C497.007 377.441 481.781 392.668 463 392.668Z",
    fill: "#F74850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 15.582H255.946V392.668H463C481.782 392.668 497.007 377.442 497.007 358.661V49.589C497.007 30.8072 481.781 15.582 463 15.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9943 204.125V358.661C14.9943 377.443 30.2194 392.668 49.0012 392.668H462.999C481.781 392.668 497.006 377.443 497.006 358.661V204.125H14.9943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.946 204.125V392.668H463C481.782 392.668 497.007 377.443 497.007 358.661V204.125H255.946Z",
    fill: "#F74850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.975 496.504L189.279 392.668H322.131L336.763 496.492L172.975 496.504Z",
    fill: "#166DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.946 496.504L336.763 496.498L322.131 392.674H255.946V496.504Z",
    fill: "#166DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.604 511.412H137.396C129.116 511.412 122.402 504.699 122.402 496.418C122.402 488.137 129.116 481.424 137.396 481.424H374.604C382.884 481.424 389.598 488.137 389.598 496.418C389.598 504.699 382.884 511.412 374.604 511.412Z",
    fill: "#166DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.604 481.424H255.946V511.412H374.604C382.884 511.412 389.598 504.699 389.598 496.418C389.598 488.137 382.884 481.424 374.604 481.424Z",
    fill: "#166DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.976 321.158C392.095 321.158 407.594 305.659 407.594 286.541C407.594 267.422 392.095 251.923 372.976 251.923C353.857 251.923 338.358 267.422 338.358 286.541C338.358 305.659 353.857 321.158 372.976 321.158Z",
    fill: "#FFA64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.976 251.923V321.158C392.095 321.158 407.594 305.659 407.594 286.541C407.594 267.422 392.095 251.923 372.976 251.923Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.447 326.512H350.025L350.023 326.519C330.848 326.67 315.35 342.254 315.35 361.465V369.312C315.35 371.739 316.315 374.067 318.031 375.784C319.747 377.5 322.075 378.464 324.503 378.464H421.247C423.674 378.464 426.002 377.5 427.719 375.784C429.435 374.067 430.399 371.739 430.399 369.312V361.465C430.399 342.161 414.75 326.512 395.447 326.512Z",
    fill: "#7AFFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.446 326.512H372.975V378.464H421.247C423.674 378.464 426.002 377.5 427.718 375.784C429.435 374.067 430.399 371.739 430.399 369.312V361.465C430.399 342.161 414.75 326.512 395.446 326.512Z",
    fill: "#00ECCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.641 321.158C158.76 321.158 174.259 305.659 174.259 286.541C174.259 267.422 158.76 251.923 139.641 251.923C120.523 251.923 105.024 267.422 105.024 286.541C105.024 305.659 120.523 321.158 139.641 321.158Z",
    fill: "#FFCC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.642 251.923V321.158C158.76 321.158 174.259 305.659 174.259 286.541C174.259 267.422 158.76 251.923 139.642 251.923Z",
    fill: "#FFB366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.112 326.512H116.69L116.688 326.519C97.5137 326.67 82.0156 342.254 82.0156 361.465V369.312C82.0156 371.739 82.9799 374.067 84.6963 375.784C86.4128 377.5 88.7407 378.464 91.1681 378.464H187.912C190.339 378.464 192.667 377.5 194.384 375.784C196.1 374.067 197.065 371.739 197.065 369.312V361.465C197.065 342.161 181.416 326.512 162.112 326.512Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.112 326.512H139.641V378.464H187.912C190.34 378.464 192.668 377.5 194.384 375.784C196.1 374.067 197.065 371.739 197.065 369.312V361.465C197.065 342.161 181.416 326.512 162.112 326.512Z",
    fill: "#FF641A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.976 146.805C392.095 146.805 407.594 131.306 407.594 112.187C407.594 93.0682 392.095 77.5693 372.976 77.5693C353.857 77.5693 338.358 93.0682 338.358 112.187C338.358 131.306 353.857 146.805 372.976 146.805Z",
    fill: "#FFA64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.976 77.5693V146.805C392.095 146.805 407.594 131.306 407.594 112.187C407.594 93.0684 392.095 77.5693 372.976 77.5693Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.447 152.159H350.025L350.023 152.166C330.848 152.317 315.35 167.901 315.35 187.111V194.958C315.35 197.386 316.315 199.714 318.031 201.43C319.747 203.147 322.075 204.111 324.503 204.111H421.247C423.674 204.111 426.002 203.147 427.719 201.43C429.435 199.714 430.399 197.386 430.399 194.958V187.111C430.399 167.808 414.75 152.159 395.447 152.159Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.446 152.159H372.975V204.111H421.247C423.674 204.111 426.002 203.147 427.718 201.43C429.435 199.714 430.399 197.386 430.399 194.958V187.111C430.399 167.808 414.75 152.159 395.446 152.159Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.641 146.805C158.76 146.805 174.259 131.306 174.259 112.187C174.259 93.0682 158.76 77.5693 139.641 77.5693C120.523 77.5693 105.024 93.0682 105.024 112.187C105.024 131.306 120.523 146.805 139.641 146.805Z",
    fill: "#FFCC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.642 77.5693V146.805C158.76 146.805 174.259 131.306 174.259 112.187C174.259 93.0684 158.76 77.5693 139.642 77.5693Z",
    fill: "#FFB366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.112 152.159H116.69L116.688 152.166C97.5137 152.317 82.0156 167.901 82.0156 187.111V194.958C82.0156 197.386 82.9799 199.714 84.6963 201.43C86.4128 203.147 88.7407 204.111 91.1681 204.111H187.912C190.339 204.111 192.667 203.147 194.384 201.43C196.1 199.714 197.065 197.386 197.065 194.958V187.111C197.065 167.808 181.416 152.159 162.112 152.159Z",
    fill: "#00ECCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.112 152.159H139.641V204.111H187.912C190.34 204.111 192.668 203.147 194.384 201.43C196.1 199.714 197.065 197.386 197.065 194.958V187.111C197.065 167.808 181.416 152.159 162.112 152.159Z",
    fill: "#00CFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.962 407.662H45.0388C20.1643 407.662 0 387.498 0 362.623V45.6257C0 20.7522 20.1643 0.587891 45.0388 0.587891H466.963C491.837 0.587891 512.001 20.7522 512.001 45.6257V362.624C512 387.498 491.836 407.662 466.962 407.662ZM45.0388 30.5764C36.7269 30.5764 29.9885 37.3138 29.9885 45.6257V362.623C29.9885 370.935 36.7269 377.674 45.0388 377.674H466.962C475.274 377.674 482.012 370.935 482.012 362.623V45.6257C482.012 37.3138 475.274 30.5754 466.962 30.5754L45.0388 30.5764Z",
    fill: "#166DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.739 0.587891H255.946V30.5764H470.739C476.964 30.5764 482.012 35.6235 482.012 41.8491V361.681C482.012 370.513 474.851 377.674 466.019 377.674H255.946V407.662H470.739C493.527 407.662 512 389.189 512 366.401V41.8491C512 19.0608 493.527 0.587891 470.739 0.587891Z",
    fill: "#295FCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/Class.ff4691e43c752dc466db2ed2fe0d125c.svg";
export { ForwardRef as ReactComponent };